import React from 'react';
import { TickThickIcon } from '../../LegacyIcons';

const CheckboxButton = ({
  id,
  children,
  checked = false,
  onChange = () => {},
  ...props
}) => {
  return (
    <span className="c-checkbox-button c-checkbox-button--checkbox">
      <input
        {...props}
        id={id}
        name={id}
        className="c-checkbox-button__input"
        checked={checked ? 'checked' : ''}
        onChange={onChange}
        type="checkbox"
      />
      <label className="c-checkbox-button__label" htmlFor={id}>
        <span className="c-checkbox-button__icon-container">
          <TickThickIcon className="c-checkbox-button__icon" />
        </span>
        <span className="c-checkbox-button__label-text">{children}</span>
      </label>
    </span>
  );
};

export default CheckboxButton;
